import { render, staticRenderFns } from "./revoke.vue?vue&type=template&id=bad0bd4c&scoped=true&"
import script from "./revoke.vue?vue&type=script&lang=js&"
export * from "./revoke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad0bd4c",
  null
  
)

export default component.exports